<template>
  <div class="content-container">
    <el-breadcrumb separator="/" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单</el-breadcrumb-item>
      <el-breadcrumb-item>编辑订单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="flex-row-between">
        <div class="flex">
          <div class="number-info" style="min-width: 330px; margin-right: 20px">
            <span class="title">客户名称</span>
            <div class="flex-row-base">
              <div style="line-height: 32px; font-size: 14px">
                {{ order.quotation_customer.name }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-button
            icon="el-icon-check"
            size="medium"
            type="primary"
            @click="postOrder"
            :loading="submiting"
            >保存
          </el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-form
        ref="orderForm"
        label-width="70px"
        :model="order"
        :rules="rules"
        label-position="top"
        class="order-form"
        size="small"
      >
        <el-form-item label="报价类型" prop="quotation_type">
          <el-select v-model="order.quotation_type" style="width: 100%">
            <el-option key="1" label="备件" :value="1"></el-option>
            <el-option key="2" label="服务" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="项目" prop="project_name">
          <el-input v-model="order.project_name" size="small"></el-input>
        </el-form-item> -->
        <el-form-item label="联系人" prop="customer_contact_id">
          <el-select
            size="small"
            v-model="order.customer_contact_id"
            allow-creates
            filterable
            placeholder="请选择报价联系人"
          >
            <el-option
              v-for="item in contacts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span style="float: left"
                >{{ item.name }}({{ item.mobile }})</span
              >
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.duty
              }}</span>
            </el-option>
          </el-select>
          <el-button
            style="margin-left: 10px"
            type="primary"
            size="small"
            plain
            icon="el-icon-plus"
            @click="startCustomerContactFormer"
            >新联系人</el-button
          >
        </el-form-item>
        <el-form-item
          label="最终用户"
          prop="customer_id"
          :rules="[{ validator: checkInstallCustomerId, trigger: 'change' }]"
        >
          <CustomerSelector
            v-model="order.customer_id"
            :category="6"
          ></CustomerSelector>
        </el-form-item>
        <el-form-item label="机会种类" prop="business_opportunity_type">
          <BusinessOpportunitySelector
            v-model="order.business_opportunity_type"
          ></BusinessOpportunitySelector>
        </el-form-item>
        <el-form-item label="关联Campaign" prop="campaign_id">
          <CampaingnSelect
            v-model="order.campaign_id"
            :tag="1"
          ></CampaingnSelect>
        </el-form-item>
        <!-- <el-form-item label="业务机会编号" prop="business_chance_number">
          <ServiceQuestSelect
            style="width: 100%"
            :customerid="customerID"
            v-model="order.business_chance_number"
          ></ServiceQuestSelect>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <h2>商品清单</h2>
        <el-button
          @click="addDevice"
          size="small"
          type="primary"
          icon="el-icon-plus"
          class="mt-10"
          >添加设备</el-button
        >
      </div>
      <template v-if="order.devices.length > 0">
        <ul class="devices">
          <li v-for="(device, index) in order.devices" :key="index">
            <div class="device-header">
              <div class="flex flex-align-center">
                <div class="font-12">设备{{ index + 1 }}：</div>
                <CustomerDeviceSelect
                  style="width: 50%"
                  :customerID="customerID"
                  :val="device.customer_device_id"
                  @change="device.customer_device_id = $event"
                >
                </CustomerDeviceSelect>
                <el-button
                  size="mini"
                  @click="openItemSelector(device, index)"
                  type="primary"
                  class="ml-10"
                  plain
                  >选择商品</el-button
                >
                <el-popconfirm
                  title="确认删除该设备吗？"
                  @confirm="removeDevice(index)"
                >
                  <el-button
                    size="mini"
                    type="danger"
                    class="ml-10"
                    slot="reference"
                    plain
                    >删除设备</el-button
                  >
                </el-popconfirm>
                <el-link
                  class="ml-10 font-12"
                  type="primary"
                  :underline="false"
                  v-if="device.customer_device_id"
                  @click="openDeviceWiki(device)"
                  >技术资料</el-link
                >
              </div>
            </div>
            <el-table sizi="mini" :data="device.items" style="width: 100%">
              <el-table-column
                prop="item.part_number"
                label="件号"
              ></el-table-column>
              <el-table-column
                prop="item.description"
                label="描述"
              ></el-table-column>
              <el-table-column label="价格(￥)" width="200">
                <template slot-scope="scope">
                  <el-input
                    size="mini"
                    class="font-14"
                    v-model.number="scope.row.price"
                    @change="recalculateItemFee()"
                  ></el-input>
                  <div class="price-info">
                    <span>原价：{{ scope.row.item.price }}</span>
                    <span>
                      {{
                        priceIncreasePercent(
                          scope.row.item.price,
                          scope.row.price,
                        )
                      }}%
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量" width="120">
                <template slot-scope="scope">
                  <el-input-number
                    size="mini"
                    v-model="scope.row.count"
                    :step="1"
                    :min="0"
                    @change="recalculateItemFee()"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                  <el-button
                    class="text-danger"
                    type="text"
                    size="mini"
                    @click="removeDeviceItem(index, scope.$index)"
                    >移除
                  </el-button>
                  <br />
                  <el-button
                    type="text"
                    size="mini"
                    @click="showCustomerDeviceDialog(index, scope.$index)"
                    >变更关联设备
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </li>
        </ul>
        <div class="clearfix mt-10">
          <div style="margin-right: 178px; float: right">
            <label class="text-info-12">整体调价</label>
            <el-input-number
              style="width: 128px"
              :step="1"
              size="mini"
              v-model="deviceIncrease"
              :step-strictly="true"
            ></el-input-number
            >%
          </div>
        </div>
      </template>
    </div>

    <el-row :gutter="14" class="flex-row">
      <el-col :span="12">
        <template>
          <div class="panel mt-20" style="height: 97%">
            <div class="header">
              <h2>结算</h2>
            </div>
            <ul class="fee-list">
              <li>
                <div class="title">小计</div>
                <div class="symbol"></div>
                <div class="amount">
                  <span class="mr-10">{{ math.show(displayFee.item) }}</span>
                </div>
              </li>
              <li>
                <div class="title">税费（13%）</div>
                <div class="symbol">+</div>
                <div class="amount">
                  <span class="mr-10">{{ math.show(displayFee.tax) }}</span>
                </div>
              </li>
              <li>
                <div class="title">杂项</div>
                <div class="symbol">+</div>
                <div class="amount">
                  <el-input
                    size="small"
                    v-model="order.labor_fee"
                    @change="recalculateItemFee()"
                    class="t-a-r"
                    placeholder
                  ></el-input>
                </div>
              </li>
              <li>
                <div class="title">
                  <span>折扣金额（含税）</span>
                </div>
                <div class="symbol">-</div>
                <div class="amount">
                  <el-input
                    size="small"
                    v-model="order.discount_value"
                    placeholder
                    class="t-a-r"
                    @change="changedDiscountValue"
                  ></el-input>
                </div>
              </li>
              <li>
                <div class="title">最终折扣</div>
                <div class="symbol"></div>
                <div class="amount">
                  <span class="mr-10"
                    >{{ displayFee.discount.toFixed(2) }}%</span
                  >
                </div>
              </li>
              <li>
                <div class="title">合计</div>
                <div class="amount">{{ math.show(displayFee.total) }}</div>
              </li>
            </ul>
          </div>
        </template>
      </el-col>
      <el-col :span="16" style="flex-grow: 1; padding-top: 20px">
        <div class="panel" style="height: 100%">
          <div class="header">
            <h2>其他信息</h2>
          </div>
          <el-form class="info-form" label-width="100px" label-position="left">
            <el-form-item label="收货地址">
              <el-input
                v-model="order.receive_address.detail"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人">
              <el-input
                v-model="order.receive_address.contact_name"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人电话">
              <el-input
                v-model="order.receive_address.contact_phone"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="发票信息">
              <el-select
                style="width: 100%"
                size="small"
                v-model="invoiceIndex"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in invoices"
                  :key="item.id"
                  :label="item.title"
                  :value="index + 1"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收票地址">
              <el-input
                v-model="order.invoice_address.detail"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收票人">
              <el-input
                v-model="order.invoice_address.contact_name"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收票人电话">
              <el-input
                v-model="order.invoice_address.contact_phone"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收票人邮箱">
              <el-input
                v-model="order.invoice_address.email"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" class="ql-editor-item">
              <el-input
                type="textarea"
                v-model="order.remark"
                :rows="2"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <div class="panel mt-20">
      <el-button
        icon="el-icon-check"
        size="medium"
        type="primary"
        @click="postOrder"
        :loading="submiting"
        >保存
      </el-button>
    </div>
    <ItemSelector
      :show.sync="itemSelectorVisible"
      :selection="itemSelection"
      @selected="doneSelectedItems"
      :deviceid="optionDeviceId"
    >
    </ItemSelector>
    <CustomerDeviceSelector
      :show.sync="deviceSelectorVisible"
      :customerID="customerID"
      @selected="handleCustomerDeviceSelected"
    ></CustomerDeviceSelector>
    <CustomerContactFormer
      :model="customerContactForm"
      :show.sync="createCustomerContactFormVisible"
      @created="createdCustomerContact"
    ></CustomerContactFormer>
    <DeviceWikiDrawer
      :model="wikiModel"
      :show.sync="wikiVisible"
    ></DeviceWikiDrawer>
  </div>
</template>

<script>
import {
  customerDetail,
  customerInvoiceList,
  customerContactList,
  createCommodityOrderQuote,
  commodityOrderDetail,
} from '@/service/getData'
import ItemSelector from '@/components/commodity_selector'
import CustomerContactFormer from '@/components/customer_contact'
import ServiceQuestSelect from '@/components/select/service_quest_select'
import CustomerDeviceSelect from '@/components/select/customer_device_select'
import DeviceWikiDrawer from '@/views/quotation/DeviceWikiDrawer'
import CustomerDeviceSelector from './CustomerDeviceSelector.vue'

import math from '@/util/math'
import { DisplayOrderFee } from '@/util/order_calculate'
import { priceIncreasePercent, CustomerAddress } from '@/util/index'
import CampaingnSelect from '@/views/leads/CampaingnSelect.vue'

export default {
  components: {
    CustomerDeviceSelect,
    ItemSelector,
    CustomerContactFormer,
    ServiceQuestSelect,
    DeviceWikiDrawer,
    CustomerDeviceSelector,
    CampaingnSelect,
  },
  data() {
    return {
      math,
      priceIncreasePercent,
      submiting: false,
      orderID: parseInt(this.$route.query.order),
      customerID: parseInt(this.$route.query.customer),
      order: {
        quotation_customer_id: '',
        quotation_customer: { name: '', category: 0 },
        quotation_type: '',
        customer_contact_id: '',
        customer_id: null,
        campaign_id: null,
        business_opportunity_type: null,
        devices: [],
        labor_fee: 0,
        total_fee: 0,
        discount: 0,
        discount_value: 0,
        amount: 0,
        itemFee: 0,
        receive_address: {
          contact_name: '',
          contact_phone: '',
          detail: '',
        },
        invoice_address: {
          contact_name: '',
          contact_phone: '',
          detail: '',
          email: '',
        },
      },
      invoiceIndex: '',
      invoices: [],
      contacts: [],
      rules: {
        quotation_type: [
          { required: true, message: '请选择报价类型', trigger: 'change' },
        ],
        customer_contact_id: [
          { required: true, message: '请选择联系人', trigger: 'change' },
        ],
        // project_name: [
        //   { required: true, message: '请输入项目名称', trigger: 'change' },
        // ],
      },
      createCustomerContactFormVisible: false,
      customerContactForm: {
        name: '',
        duty: '',
        mobile: '',
        email: '',
      },
      displayFee: {
        item: 0,
        tax: 0,
        labor: 0,
        discount: 0,
        discount_value: 0,
        total: 0,
      },
      optionDeviceId: 0,
      itemSelectorVisible: false,
      itemSelection: [],
      itemSelectionIndex: -1,
      wikiModel: {},
      wikiVisible: false,
      deviceIncrease: 0,
      deviceSelectorVisible: false,
      deviceSelectorIndex: -1,
      deviceSelectorItemIndex: -1,
    }
  },
  watch: {
    'order.customer_contact_id': function () {
      for (let index = 0; index < this.contacts.length; index++) {
        const element = this.contacts[index]
        if (element.id == this.order.customer_contact_id) {
          this.order.receive_address.contact_name = element.name
          this.order.receive_address.contact_phone = element.mobile
          break
        }
      }
    },
    invoiceIndex(index) {
      if (index) {
        let invoice = this.invoices[index - 1]
        this.order.invoice_address.contact_name = invoice.consignee_name
        this.order.invoice_address.contact_phone = invoice.consignee_mobile
        this.order.invoice_address.detail = invoice.consignee_address
        this.order.invoice_address.email = invoice.consignee_email
      }
    },
    deviceIncrease: function () {
      const percent = math.add(
        math.divide(parseInt(this.deviceIncrease), 100),
        1,
      )
      this.order.devices.map((device) => {
        device.items.map((item) => {
          const price = math.multiply(item.item.price, percent)
          item.price = math.toFixed(price)
        })
      })
      this.recalculateItemFee()
    },
  },
  created() {
    if (this.orderID > 0) {
      this.requestOrderInfo()
    } else {
      this.order.quotation_customer_id = this.customerID
      this.requestCustomer()
      this.requestCustomerInvoices()
      this.requestCustomerContactList()
    }
  },
  methods: {
    openDeviceWiki(deivce) {
      this.wikiModel = deivce
      this.wikiVisible = true
    },
    async requestOrderInfo() {
      let res = await commodityOrderDetail(this.orderID)
      if (res.code == 0) {
        res.data.devices = this.formartOrderDevices(res.data.items)
        res.data.discount_value = res.data.discount

        if (res.data.receive_address_id > 0) {
          res.data.receive_address = res.data.addresses.filter(
            (item) => item.category == 1,
          )[0]

          res.data.invoice_address = res.data.addresses.filter(
            (item) => item.category == 2,
          )[0]
        } else {
          res.data.receive_address = this.order.receive_address
          res.data.invoice_address = this.order.invoice_address
        }

        if (res.data.quotation_type == 0) {
          res.data.quotation_type = ''
        }
        this.order = res.data
        this.customerID = res.data.quotation_customer_id
        this.recalculateItemFee()

        this.requestCustomerInvoices()
        this.requestCustomerContactList()
      }
    },
    formartOrderDevices(items = []) {
      let itemGroup = this.groupBy(items, function (item) {
        return [item.customer_device_id]
      })
      let devices = itemGroup.map((items) => {
        items = items.map((item) => {
          item.item = {
            part_number: item.part_number,
            description: item.description,
            price: item.original_price,
          }
          item.count = item.number
          item.item_id = item.commodity_id
          return item
        })
        return {
          customer_device_id: items[0].customer_device_id,
          items: items,
        }
      })
      return devices
    },
    async requestCustomer() {
      let res = await customerDetail(this.customerID)
      this.order.quotation_customer.name = res.data.name
      this.order.quotation_customer.category = res.data.category
      this.order.receive_address.detail = CustomerAddress(res.data)
    },
    async requestCustomerInvoices() {
      let res = await customerInvoiceList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.invoices = res.data.list
    },
    async requestCustomerContactList() {
      let res = await customerContactList({
        customer_id: this.customerID,
      })
      if (res.code == 0) {
        this.contacts = res.data.list
      }
    },
    postOrder() {
      this.$refs.orderForm.validate(async (valid) => {
        if (valid) {
          if (
            this.order.type == 2 &&
            this.order.devices.filter((item) => !item.customer_device_id)
              .length > 0
          ) {
            this.$alert(
              '服务类型报价下产品清单中设备不能为空，请选择设备或删除空设备！',
            )
            return
          }

          if (this.order.devices.length == 0) {
            this.$alert('商品不能为空！')
            return
          }

          this.submiting = true
          let data = {
            quotation_customer_id: this.order.quotation_customer_id,
            quotation_type: this.order.quotation_type,
            customer_contact_id: this.order.customer_contact_id,
            customer_id: this.order.customer_id,
            business_opportunity_type: this.order.business_opportunity_type,
            campaign_id: this.order.campaign_id,
            items: [],
            labor_fee: this.order.labor_fee, //杂项
            discount: this.order.discount_value, //折扣金额
            total_price: this.order.amount, //最终支付价
            receive_address: this.order.receive_address,
            invoice_address: this.order.invoice_address,
            remark: this.order.remark,
          }

          this.order.devices.map((device) => {
            device.items.map((item) => {
              data.items.push({
                commodity_id: item.item_id,
                price: item.price,
                number: item.count,
                customer_device_id: device.customer_device_id || 0,
              })
            })
          })

          if (this.order.id) {
            data.id = this.order.id
          }

          let res = await createCommodityOrderQuote(data)
          if (res.code == 0) {
            this.$router.push(
              '/dashboard/shop/application_orders/' + res.data.id,
            )
          }
          this.submiting = false
        }
      })
    },
    startCustomerContactFormer() {
      this.customerContactForm = {
        customer_id: this.customerID,
        name: '',
        duty: '',
        mobile: '',
        email: '',
      }
      this.createCustomerContactFormVisible = true
    },
    createdCustomerContact(contact) {
      this.contacts.unshift(contact)
      this.order.customer_contact_id = contact.id
    },
    checkInstallCustomerId(rule, value, callback) {
      const devices = this.order.devices
      if (!devices) {
        return callback()
      }
      var hasServiceOrOffCommodiy = false
      for (let index = 0; index < devices.length; index++) {
        const device = devices[index]
        hasServiceOrOffCommodiy =
          device.items.filter(
            (item) => item.item.type == 2 || item.item.status == 0,
          ).length > 0
        if (hasServiceOrOffCommodiy) {
          break
        }
      }

      if (
        this.order.quotation_customer.category != 6 &&
        hasServiceOrOffCommodiy &&
        !value
      ) {
        return callback(
          new Error(
            '报价对象为中间商且商品包含服务或非上架商品时，最终用户为必选项',
          ),
        )
      } else {
        callback()
      }
    },
    addDevice() {
      this.order.devices.push({
        customer_device_id: '',
        items: [],
      })
    },
    removeDevice(index) {
      this.order.devices.splice(index, 1)
      this.recalculateItemFee()
    },
    removeDeviceItem(index, itemIndex) {
      this.order.devices[index].items.splice(itemIndex, 1)
      this.recalculateItemFee()
    },
    showCustomerDeviceDialog(index, itemIndex) {
      this.deviceSelectorVisible = true
      this.deviceSelectorIndex = index
      this.deviceSelectorItemIndex = itemIndex
    },
    handleCustomerDeviceSelected(e) {
      let index = this.deviceSelectorIndex
      let itemIndex = this.deviceSelectorItemIndex
      let item = this.order.devices[index].items[itemIndex]
      if (item.customer_contact_id != e) {
        this.order.devices[index].items.splice(itemIndex, 1)
      }

      let deviceGroupIndex = this.order.devices.findIndex(
        (item) => item.customer_device_id == e,
      )
      if (deviceGroupIndex != -1) {
        this.order.devices[deviceGroupIndex].items.push(item)
      } else {
        this.order.devices.push({
          customer_device_id: e,
          items: [item],
        })
      }
      this.recalculateItemFee()
    },
    openItemSelector(device, index) {
      this.optionDeviceId = device.customer_device_id || 0
      this.itemSelectorVisible = true
      this.itemSelection = device.items.filter((i) => {
        return i.checked
      })
      this.itemSelectionIndex = index
    },
    changedDiscountValue() {
      this.recalculateItemFee()
    },
    recalculateItemFee() {
      this.displayFee = DisplayOrderFee(this.order)
    },
    doneSelectedItems(products) {
      const percent = math.add(
        math.divide(parseInt(this.deviceIncrease), 100),
        1,
      )

      let pitems = products.map((p) => {
        let qitem = {}
        qitem.price = p.price
        qitem.original_price = p.price
        if (this.deviceIncrease) {
          const price = math.multiply(p.price, percent)
          qitem.price = math.toFixed(price)
        }
        qitem.count = 1
        qitem.checked = true
        qitem.item_id = p.id
        qitem.item = p
        return qitem
      })

      let device = this.order.devices[this.itemSelectionIndex]
      this.order.devices[this.itemSelectionIndex].items =
        device.items.concat(pitems)
      this.recalculateItemFee()
    },
  },
}
</script>

<style scoped>
.q-info p {
  font-size: 14px;
  color: #333;
  margin: 0 0 10px 0;
}

.q-info p span {
  margin-left: 2em;
}

.q-info {
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.device-header {
  background-color: #fff7ea;
  border: 1px solid #e9d9c1;
  padding: 10px;
  margin-bottom: 10px;
  color: #3e4b5b;
}

h3 {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.q-products {
  background-color: #dae1f2;
}

.q-products .title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.total {
  margin-top: 10px;
  overflow: hidden;
}

.total .row {
  width: 100%;
  clear: both;
}

.total .row span {
  width: 120px;
  padding: 12px 10px;
  box-sizing: border-box;
}

.total .row span.title {
  width: 110px;
  color: #909399;
}

.device-select {
  text-align: left;
}

.device-select label {
  color: #3e4b5b;
  margin-left: 10px;
  margin-right: 3px;
  font-size: 12px;
}

.devices li {
  margin-bottom: 20px;
}

.devices li:first-child {
  margin-top: 10px;
}

.info-form .el-form-item {
  margin-top: 10px;
  margin-bottom: 0;
}

.del-device {
  border: 0 none;
  background: #fff;
}

.number-info .title {
  display: block;
  color: #adb5bd;
  line-height: 1.3;
}

.number-info .content {
  font-size: 1.5rem;
  font-weight: 500;
}

.el-table__body .el-input-number--mini {
  width: 100px !important;
}

.customer-info {
  background-color: #fff6d7;
  position: relative;
}

.customer-info li {
  display: flex;
  line-height: 24px;
}

.customer-link {
  position: absolute;
  right: 20px;
  top: 20px;
}

/deep/.rich-editor .ql-editor {
  min-height: 240px;
}

.quotation-customer li {
  border-top: 0 none;
}

.fee-list-ex {
  border: 0 none;
  padding-top: 0;
  margin-top: 4px;
}

.order-form {
  display: flex;
  flex-wrap: wrap;
}

.order-form .el-form-item {
  width: 330px;
  margin-right: 20px;
}

/deep/.order-form .el-form-item__label {
  padding: 0;
  line-height: 2;
  color: #adb5bd;
  font-size: 0.8rem;
}
</style>
